import { GroupType, Program } from '@monorepo/types';
import { ProgressStep } from '@monorepo/types';
import { BaseResponse } from '../core/base-entity-service';
import CrudService from '../core/crud-service';

export default class ProgramService extends CrudService {
  static override route = 'program';

  async getProgramsAndGroups() {
    try {
      const response = await this.httpService.get<
        BaseResponse<{ groups: GroupType[]; programs: Program[] }>
      >(`${this.path}`);
      return response.data;
    } catch (error) {
      console.error(`Failed getting programs and groups `, error);
      throw error;
    }
  }

  async getProgramProgression(programId: string): Promise<ProgressStep[]> {
    const response = await this.httpService.get<{ data: ProgressStep[] }>(
      `${this.path}/progression/${programId}`,
    );
    return response.data;
  }
}
